// Le Radar de la nouvelle interface (9 octobre 2026) : l'écran unique, sa
// bascule Sujets | Publics, et l'encart d'un recoupement ouvert au clic. Le reste
// de ses textes vient de l'espace `radar`, partagé avec l'écran classique.
export default {
  sousTitre: {
    sujets: '{s} sujets qui montent chez {p} publics',
    publics: '{p} publics observés',
  },
  vue: {
    aria: 'La vue',
    sujets: 'Sujets',
    publics: 'Publics',
    pays: 'Pays',
  },
  scene: {
    aria: 'Le radar : les sujets et les publics, par famille',
  },
  portee: {
    presqueTous: 'presque tous',
    moitie: 'la moitié',
    quelques: 'quelques-uns',
    tresConcernes: 'très concernés',
    concernes: 'concernés',
    peuConcernes: 'peu concernés',
  },
  lecture: {
    sujets: 'Au centre, ce dont tous vos publics parlent. Plus un point est gros, plus le sujet est neuf ; chaque cercle autour, un jour de plus.',
    publics: 'Au centre, les publics qui portent le plus de sujets qui montent. Plus un point est gros, plus il a de sujets du jour.',
    recoupements: 'Cliquez un trait pour comparer deux publics.',
  },
  recoupement: {
    titre: 'Recoupement d’audience',
    aria: '{a} et {b} : {pct} % en commun',
    prochesSujets: 'de sujets en commun',
    prochesPersonas: 'de personas en commun',
    sansSujets: 'Ces deux publics ne partagent aucun sujet qui monte en ce moment.',
    sansPersonas: 'Leurs personas ne se recoupent pas, ou ne sont pas encore lus.',
    sujetsCommuns: 'Les sujets qu’ils partagent',
    personasCommuns: 'Les personas qu’ils partagent',
    seul: 'Seulement chez {nom}',
    rienSeul: 'Rien qui lui soit propre',
  },
  sujet: {
    jours: 'Les jours où le sujet est revenu',
  },
  et: 'et',
  fermer: 'Fermer',
}
